import { PERMISSIONS } from '../../constants';
import list from './AttendantGoalWorkerRunList';

// Interno PontuaX (isAdmin + attendant-goal-internal, ver InternalGate). O nome é o path da API:
// GET /attendant-goal-worker-runs.
export default {
  list,
  name: 'attendant-goal-worker-runs',
  permissions: [PERMISSIONS.ATTENDANT_GOAL_INTERNAL],
};
